import ArchiveSort from './_sort.es6';

const sort = new ArchiveSort();